module.exports = __webpack_public_path__ + "img/icon-truck.529054ca.svg";